import React from 'react';

type SummaryRow = {
    class: number | null;
    description: string | null;
    count: number | null;
    unit: string | null;
    total: string | null;
};

type Props = {
    rows?: SummaryRow[];
};

const SummaryTable: React.FC<Props> = ({ rows = [] }) => {

    return (
        <table
            className="paymentlist flex-1 content w-auto table-auto text-[11px] border-collapse [&_td]:px-1 [&_td]:py-0.5 [&_td]:align-middle [&_td]:border [&_td]:border-gray-200 [&_.money]:text-right [&_.money]:font-mono"
            border={1}
            cellPadding={0}
            cellSpacing={0}
        >
            <thead className="dtaus-head sticky top-0 z-10 shadow-sm">
                <tr className="table-header">
                    <td colSpan={5} align="center">
                        Zusammenfassung
                    </td>
                </tr>
                <tr>
                    <td>Klasse</td>
                    <td>Beschreibung</td>
                    <td>Anzahl</td>
                    <td>Einzel</td>
                    <td>Summe</td>
                </tr>
            </thead>
            <tbody className="[&_tr:nth-child(even)]:bg-gray-50">
                {rows.map((r, idx) => (
                    <tr key={idx}>
                        <td align="center">{r.class ?? <>&nbsp;</>}</td>
                        <td>{r.description ?? <>&nbsp;</>}</td>
                        <td align="center" className="sum">
                            {r.count ?? <>&nbsp;</>}
                        </td>
                        <td>{r.unit ?? <>&nbsp;</>}</td>
                        <td>{r.total ?? <>&nbsp;</>}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default SummaryTable;


